var map = {
	"./Logops.png": "kDfR",
	"./add_icon.png": "BO64",
	"./bg_phone.png": "tUJu",
	"./browser_icon.png": "Z8aQ",
	"./circle1.png": "z9ZF",
	"./circle2.png": "GnhR",
	"./circle3.png": "2jWd",
	"./creater_icon.png": "Fp8a",
	"./dot.png": "f6T9",
	"./down-icon.png": "xFWD",
	"./email-1.png": "2ILf",
	"./email.png": "wF+D",
	"./emil_icon.png": "iPBD",
	"./empty.png": "OmQY",
	"./file_icon.png": "jpPc",
	"./login-bg@2x.png": "I2R7",
	"./login-main.png": "bfR1",
	"./manager_icon.png": "a32v",
	"./pc_guide.png": "JPc+",
	"./pclogo1.png": "zV7g",
	"./power.png": "FMBj",
	"./protocol_bg.png": "c/4/",
	"./qr-bg.png": "+f/g",
	"./qrcode-logo.png": "JoTp",
	"./qrcode.png": "jWhC",
	"./right-icon.png": "otcp",
	"./sprite@3x.png": "qkAg",
	"./survey_icon.png": "xhf5",
	"./task-check.png": "K8L+",
	"./task-ok.png": "3v5v",
	"./task/banner.png": "aRE/",
	"./task/bc0.png": "eLtP",
	"./task/bc1.png": "5hIW",
	"./task/bc2.png": "JmIY",
	"./task/bc3.png": "G6P4",
	"./task/bc4.png": "rWRg",
	"./template.png": "mPzE",
	"./tetragonum1.png": "cJqR",
	"./tetragonum2.png": "9Unk",
	"./title_icon.png": "PIAu",
	"./triangle1.png": "JUKd",
	"./triangle2.png": "6hgz",
	"./wj-file-icon.png": "NExZ",
	"./wj-like-icon.png": "gRe6",
	"./wj-result.png": "gB52",
	"./wj-sys-icon.png": "XjLJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "32Qh";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 32Qh
// module chunks = 1